import React from 'react';
import { t } from 'services/translation';
import styled from '@emotion/styled';

const ToBring = styled('div')`
  margin-top: 20px;
`;

const ToBringHeader = styled('div')`
  text-transform: uppercase;
  font-weight: 600;
`;

const ToBringText = styled('div')`
  margin-top: 20px;
`;

const List = styled('ul')`
  list-style-position: inside;
  margin-block-start: 20px;
  margin-block-end: 0;
  list-style: none;
`;

const CustomDetail = styled('div')`
  padding-top: 20px;
`;

// use themes for colors
const Dot = styled('span')`
  height: 2px;
  width: 2px;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
`;

const FieldAnswer = styled('div')`
  span {
    font-weight: 600;
  }
`;

const SelectAndTextAnswer = ({ experienceQuestion }) => {
  const { question, answers } = experienceQuestion;
  if (answers.length < 1) return null; // safe gaurd for accidental unanswered questions
  const answer = answers[0];
  let answerText;
  switch (question.input_type) {
    case 'select':
      answerText = answer.question_option_text;
      break;
    case 'text':
      answerText = answer.text_answer;
      break;
    default:
      answerText = null;
      break;
  }
  return (
    <FieldAnswer>
      <span> {question.guest_checkout_label}:</span> {answerText}
    </FieldAnswer>
  );
};

const WhatToBring = ({ experienceQuestions }) => {
  const parsedAnswers = experienceQuestions.map((eq) => {
    const { question, answers } = eq;
    if (question.input_type === 'list') {
      return (
        <List>
          {answers.map((answer) => (
            <li>
              <Dot />
              {answer.supply_url ? (
                <span>
                  {answer.quantity && `${answer.quantity} `}
                  <a target="blank" href={answer.supply_url}>
                    {answer.text_answer}
                  </a>
                </span>
              ) : (
                <span>
                  {answer.quantity && `${answer.quantity} `}
                  {answer.text_answer}
                </span>
              )}
            </li>
          ))}
        </List>
      );
    }
    return <ToBringText> {answers[0] && answers[0].text_answer} </ToBringText>;
  });
  return (
    <ToBring>
      <ToBringHeader> {t('WHAT_TO_BRING')}</ToBringHeader>
      {parsedAnswers}
    </ToBring>
  );
};

const CustomFields = (props) => {
  const { customFields } = props;

  const otherNotes = customFields.filter(
    (eq) =>
      eq.question.input_type !== 'list' &&
      eq.question.input_type !== 'list_open_text'
  );
  const whatToBring = customFields.filter(
    (eq) =>
      (eq.question.input_type === 'list' && eq.answers.length > 0) ||
      (eq.question.input_type === 'list_open_text' &&
        eq.answers[0] &&
        eq.answers[0].text_answer)
  );
  return (
    <CustomDetail>
      {otherNotes.map((eq) => (
        <SelectAndTextAnswer experienceQuestion={eq} />
      ))}
      {whatToBring.length > 0 && (
        <WhatToBring experienceQuestions={whatToBring} />
      )}
    </CustomDetail>
  );
};

export default CustomFields;
